import { CustomDataValuePipe } from './custom-data-value.pipe';
import { HasCustomDataPipe } from './has-custom-data.pipe';
import { InlineCustomDataColumnsPipe } from './inline-custom-data-columns.pipe';
import { IsCustomDataInlinePipe } from './is-custom-data-inline.pipe';

export {
  InlineCustomDataColumnsPipe,
  CustomDataValuePipe,
  HasCustomDataPipe,
  IsCustomDataInlinePipe,
};

export const pipes = [
  InlineCustomDataColumnsPipe,
  CustomDataValuePipe,
  HasCustomDataPipe,
  IsCustomDataInlinePipe,
];
